
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/create",
      function () {
        return require("private-next-pages/products/create/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/create"])
      });
    }
  